export default __webpack_public_path__ + "static/media/img-slider-ommerchant-7.11cec8c9.png";